<template>
  <v-card
    id="encours"
    fluid
  >
  <v-card-title class="blue darken-3">
          <span class="text-h5 white--text">{{title}}</span>

  </v-card-title>
  <template>
  <v-data-table
    :headers="headers"
    :items="data_table"
    :items-per-page="10"
    class="elevation-1"
  >
  <template v-slot:top>
    <v-toolbar flat>
      <v-toolbar-title></v-toolbar-title>

        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>


        <v-spacer></v-spacer>
                  

      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">


      <v-icon 
        v-if="true"
        small
        color="success"
        class="ma-2"
        @click="Edit_Item(item)"
        >mdi-pencil
      </v-icon>

      <v-icon
      v-if="true"
        small
        color="error"
        class="ma-2"
        @click="Delete_Item(item)"
        >mdi-delete
      </v-icon>


      <v-dialog v-model="dialogue_DELETE"
        max-width="1000px"
        style="z-index: 1000"
        :retain-focus="false"
      >
        <v-card flat>
          
          <v-card-title>
            
            <span class="headline" >Do you really want to remove this Line ?
            </span>

          </v-card-title>
          <v-card-actions>

            <v-spacer></v-spacer>

            <v-btn 
              color="success"
              class="ma-2"
              dark
              @click="Close_Item()"
              >Cancel
            </v-btn>

            <v-btn
              color="error"
              class="ma-2"
              dark
              @click="Delete_ThisItem()"
              >Yes
            </v-btn>
                          
          </v-card-actions>
          
        </v-card>
      </v-dialog>

    </template>

    <template>


    </template>



  </v-data-table>






</template>
  
<v-banner></v-banner>
<v-card> 
  <v-row align="baseline">
    <v-col cols="12" md="3">
      <v-text-field
        label="Objet"
        v-model="objet"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        label="Alpha"
        v-model="alpha"
      >}</v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model="delta"
        label="Delta"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        v-model="magv"
        label="MagV"
      ></v-text-field>
    </v-col>
  </v-row>
</v-card>


</v-card>
</template>
<script>
  
  export default {
    data: () =>({

      headers: [
          { text: 'id', value: 'id' },
          { text: 'nom', value: 'name' },
          { text: 'fname', value: 'fname' },
          { text: 'jour', value: 'jour' },
          { text: 'nuit', value: 'nuit' },
          { text: 'type', value: 'type' },
          { text: 'Actions', value: 'actions' }
        ],


  boats : [
    {
      name: 'Speedster',
      speed: 35,
      length: 22,
      price: 300000,
      year: 2021,
    },],



      tel:{
        lastpos:{"timestamp":"2073-04-01T00:00:00.000Z","st":"12h00m00s","ah":"+6h00m00s","ra":0.0,"dec":0.0,"airmass":0,"telmarche":0,"date":"2073-04-01","time":"00:00:00"},
        targets:[]
      },
      title: "SPIP",
      dialog:"",
      search:"",
      target:{},
      A_Update_targets : null,

      objet :"",
      ra:"",
      dec:"",
    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){
     

  },
  mounted(){

    this.get_Target();
    this.load_Target();
    this.A_Update_target = setInterval(() => {
      this.get_Target();
      this.load_Target();
    },2000);
  },

  methods: {

    get_Target(){

      const othis = this;


      this.axios.get( backend_url + "/Pilote/Targets")
      .then((res) => {

          othis.tel.targets = JSON.parse(JSON.stringify(res.data));
          
      })
      .catch(() => {
        console.log("PB with load Targets");
      });

    },
    load_Target(){
      var t_targets = [];
      var the_target = this.tel.targets[0];
      for(var target of this.tel.targets){
        t_targets.push(target);
      };
      if(t_targets && t_targets.length > 0){
        //console.log(t_targets[0]);
        this.objet = t_targets[0].objet;
        this.alpha = t_targets[0].alpha;        
        this.delta = t_targets[0].delta;
        this.magv = t_targets[0].magv;
      }
      
      //this.target = JSON.parse(JSON.stringify(t_targets));
      //console.log(this.target);
    },

  }
}
</script>